import React from 'react';
import Icon, { Props } from '../icon';

export const FavoriteFilledDisabled = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4426 8.84113L20.4999 9.79839L19.557 8.84099C17.8379 7.09459 15.4899 6.11115 13.0394 6.11115C10.5889 6.11115 8.24087 7.09459 6.52181 8.84099C2.93706 12.5248 2.93706 18.3931 6.52181 22.0769L16.5082 32.2169C17.561 33.2865 18.9991 33.8888 20.4999 33.8888C22.0008 33.8888 23.4388 33.2865 24.4917 32.2169L34.478 22.0771C38.0628 18.3933 38.0628 12.525 34.478 8.84115C32.7589 7.0947 30.4109 6.11121 27.9603 6.11121C25.5097 6.1112 23.1617 7.09468 21.4426 8.84113Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default React.memo(FavoriteFilledDisabled);
